import { ClipboardList, CalendarCheck, ListChecks, FileText, Timer, Route } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const ITEMS = [
  {
    icon: ClipboardList,
    title: "Quiz di autovalutazione",
    text: "5 domande per capire esattamente quanto la tua attività dipende da te, e da dove partire.",
  },
  {
    icon: CalendarCheck,
    title: "Percorso guidato di 7 giorni",
    text: "Un giorno alla volta, una procedura alla volta: impari a delegare senza ansia e senza stravolgere la tua azienda.",
    large: true,
  },
  {
    icon: ListChecks,
    title: "Checklist compilabili",
    text: "Individui in pochi minuti le attività che puoi affidare subito ai tuoi collaboratori.",
  },
  {
    icon: FileText,
    title: "Schede e modelli pratici",
    text: "SOP e schede di assegnazione per dare responsabilità senza perdere il controllo.",
  },
  {
    icon: Timer,
    title: "Sistema di misurazione",
    text: "Calcoli il tempo che inizi a recuperare, ora dopo ora. La libertà si misura.",
    large: true,
  },
  {
    icon: Route,
    title: "Piano d'azione di 30 giorni",
    text: "Quattro settimane per consolidare i risultati e rendere il cambiamento permanente.",
  },
];

export const Bento = () => (
  <section id="contenuti" className="bg-sand/60 py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal className="max-w-2xl">
        <span className="font-mono text-[11px] uppercase tracking-[0.25em] text-terracotta">Cosa trovi all'interno</span>
        <h2 className="mt-4 font-serif text-2xl tracking-tight text-ink sm:text-3xl lg:text-4xl">
          Tutto quello che serve per <em className="italic text-terracotta">delegare davvero</em>
        </h2>
        <p className="mt-4 text-base text-taupe">
          Niente teoria motivazionale: strumenti operativi che usi dal primo giorno.
        </p>
      </Reveal>

      <div data-testid="bento-grid-container" className="mt-14 grid gap-5 md:grid-cols-2 lg:grid-cols-3">
        {ITEMS.map((item, i) => (
          <Reveal key={item.title} delay={i * 0.08} className={item.large ? "lg:col-span-2" : ""}>
            <div className="group h-full rounded-[1.75rem] border border-ink/8 bg-white p-8 transition-all duration-500 hover:-translate-y-1.5 hover:shadow-2xl hover:shadow-espresso/10">
              <div className="flex items-start justify-between">
                <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-terracotta/10 text-terracotta transition-colors duration-500 group-hover:bg-terracotta group-hover:text-linen">
                  <item.icon className="h-5 w-5" />
                </div>
                <span className="font-mono text-xs text-stone2">0{i + 1}</span>
              </div>
              <h3 className="mt-6 font-serif text-xl text-ink">{item.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-taupe">{item.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
